<div #yourInfoWrapper>

  <div class="option-wrapper">
    <div class="variant-wrapper my-2 my-md-0">
      <div class="p-3 section-title mt-3 mt-md-0 mb-3 font-size-heading pl-4 theme-light"
        *ngIf="!checkoutService.showChoices()">
        {{'public.checkout.title.addressDelivery' | translate}}
      </div>
      <app-customer-login></app-customer-login>
      <!-- FORM -->
      <div class="expandable-content-wrapper">
        <form class="mx-3" [formGroup]="personalInfoForm">
          <!-- Your name -->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-input-text class="mb-4" inputId="name" autocomplete="name" maxLength="200"
                  [label]="'public.checkout.yourName' | translate" [required]="true" [control]="getControl('name')"
                  [isInvalid]="checkoutService.isInvalid(getControl('name'))" [errorText]="
                      getControl('name')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) :
                      getControl('name')?.errors?.whitespace || getControl('name')?.errors?.containsUrl ? ('public.payment.errors.valueNotValid' | translate) : ''
                    " (changeEvent)="addOrderMeta('customerName', 'name', 'personalInfoForm')" appPreventEnter />
              </div>
            </div>
          </div>
          <!-- Email -->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-input-text class="mb-4" inputId="email" autocomplete="email" maxLength="200"
                                [label]="'public.checkout.email' | translate" [required]="!isAdminOrderCaptureUpdate"
                                [isDisabled]="auth.isUserLoggedIn()" [control]="getControl('email')"
                                [isInvalid]="(checkoutService.isInvalid(getControl('email')) || getControl('email').errors?.email)"
                                [errorText]="
                      getControl('email')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) :
                      (
                        getControl('email')?.errors?.email ||
                        getControl('email')?.errors?.whitespace ||
                        getControl('email')?.errors?.minlength ||
                        getControl('email')?.errors?.maxlength
                      ) ? ('public.payment.errors.valueNotValid' | translate) : ''
                    " (changeEvent)="addOrderMeta('customerEmail', 'email', 'personalInfoForm')" appPreventEnter />
              </div>
            </div>
          </div>
          <!-- Phone Number -->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-phone-input [id]="'phone'" [countryCode]="countryCode()" [formControl]="getControl('phone')"
                                 [invalidSubmit]="checkoutService.invalidSubmit()" [required]="true"
                                 (inputChange)="addOrderMeta('customerPhoneNumber', 'phone', 'personalInfoForm');"
                                 (change)="addOrderMeta('customerPhoneNumber', 'phone', 'personalInfoForm');"
                                 [countryName]="getCountryNameCode()">
                </app-phone-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex justify-content-between align-items-center m-2">
                <div class="sub-title">
                  {{ 'public.checkout.yourAddress' | translate }}
                </div>
                <div>
                  <app-button [endIcon]="'fa-arrow-right'" (click)="openSelectAddressDialog()">
                    {{ 'public.checkout.savedAddresses' | translate }}
                  </app-button>
                </div>
              </div>
            </div>
          </div>
          <!-- Street -->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <div #igTextarea class="input-group mb-4">
                  <input #street type="text" class="form-control"
                    [ngClass]="{'is-invalid': (checkoutService.isInvalid(getControl('street')) || checkoutService.isNotDeliverableAddress()), 'populated': !!getControl('street').value}"
                    [attr.autocomplete]="getControl('street').value ? 'none' : 'street-address'"
                    [formControl]="getControl('street')" maxlength="128" placeholder=""
                    (change)="addOrderMeta('customerStreet', 'street', 'personalInfoForm')"
                    (focus)="helper.focusTextArea(igTextarea); initiateGoogleApi();" (focusout)="onFocusOutEvent()"
                    trim="blur" appPreventEnter />
                  <label for="#street" class="placeholder font-size-primary"
                    (click)="checkoutService.focusField($event)">{{'public.checkout.streetAddress' | translate}}
                    *</label>
                  <div class="invalid-feedback font-size-secondary"
                    *ngIf="checkoutService.showErrors(getControl('street'))">
                    <span *ngIf="getControl('street').errors.required">{{'public.checkout.errors.fieldRequired' |
                      translate}}.</span>
                    <span
                      *ngIf="!getControl('street').errors.required && (getControl('street').errors.whitespace || getControl('street').errors.maxlength)">{{'public.payment.errors.valueNotValid'
                      | translate}}</span>
                  </div>
                  <div class="invalid-feedback font-size-secondary"
                    *ngIf="!getControl('street').errors && checkoutService.isNotDeliverableAddress()">
                    <span>{{'public.payment.errors.addressNotAvailable' | translate}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Floor -->
          <div class="row" *ngIf="!deliveryFloorHidden()">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-input-text class="mb-4" inputId="floor" maxLength="50"
                  [label]="'public.checkout.floor' | translate" [required]="deliveryFloorRequired()" [control]="getControl('floor')"
                  [isInvalid]="checkoutService.isInvalid(getControl('floor'))" [errorText]="
                      getControl('floor')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) :
                      (
                        getControl('floor')?.errors?.whitespace ||
                        getControl('floor').errors?.maxlength
                      ) ? ('public.payment.errors.valueNotValid' | translate) : ''
                    " (changeEvent)="addOrderMeta('customerFloor', 'floor', 'personalInfoForm')" appPreventEnter />
              </div>
            </div>
          </div>
          <!-- Doorbell -->
          <div class="row" *ngIf="!deliveryDoorbellHidden()">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-input-text class="mb-4" inputId="doorbell" maxLength="50"
                  [label]="'public.checkout.doorbell' | translate" [required]="deliveryDoorbellRequired()" [control]="getControl('doorbell')"
                  [isInvalid]="checkoutService.isInvalid(getControl('doorbell'))" [errorText]="
                      getControl('doorbell')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) :
                      (
                        getControl('doorbell')?.errors?.whitespace ||
                        getControl('doorbell').errors?.maxlength
                      ) ? ('public.payment.errors.valueNotValid' | translate) : ''
                    " (changeEvent)="addOrderMeta('doorbell', 'doorbell', 'personalInfoForm')" appPreventEnter />
              </div>
            </div>
          </div>
          <!-- Zip / Postal code -->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-input-text class="mb-4" inputId="zip"
                  [autocomplete]="getControl('street').value ? 'none' : 'postal-code'" maxLength="16"
                  [label]="'public.checkout.zip' | translate" [required]="true" [control]="getControl('zip')"
                  [isInvalid]="(checkoutService.isInvalid(getControl('zip')) || (getControl('zip').value && checkoutService.isNotDeliverablePostCode()))"
                  [errorText]="
                      getControl('zip')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) :
                      (
                        getControl('zip')?.errors?.whitespace ||
                        getControl('zip')?.errors?.maxlength
                      ) ? ('public.payment.errors.valueNotValid' | translate) :
                      checkoutService.isNotDeliverablePostCode() ? ('public.payment.errors.zipNotAvailable' | translate) : ''
                    " appPreventEnter />
              </div>
            </div>
          </div>
          <!-- Town / City -->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-input-text class="mb-4" inputId="town"
                  [autocomplete]="getControl('street').value ? 'none' : 'address-level2'" maxLength="64"
                  [label]="'public.checkout.town' | translate" [required]="true" [control]="getControl('town')"
                  [isInvalid]="checkoutService.isInvalid(getControl('town'))" [errorText]="
                      getControl('town')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) :
                      getControl('town')?.errors?.whitespace ? ('public.payment.errors.valueNotValid' | translate) : ''
                    " (changeEvent)="addOrderMeta('customerTown', 'town', 'personalInfoForm')"
                  (focusoutEvent)="onFocusOutEvent()" appPreventEnter />
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- FORM END -->
    </div>
  </div>

  <div class="form-group row ml-4" *ngIf="auth.isUserLoggedIn() && checkoutService.isShowOnlyDeliveryToAddress()">
    <div class="loading-screen d-flex justify-content-center align-items-center w-100"
      *ngIf=" customerDetailsChanged() && customerDetailsUpdateStatus === 'LOADING'">
      <div class="d-flex flex-column text-center">
        <div class="lds-ripple mx-auto"></div>
        <div class="loading-message">{{'public.load.loadingMessage' | translate}}</div>
      </div>
    </div>
    <div class="font-size-secondary" *ngIf=" customerDetailsChanged() && customerDetailsUpdateStatus !== 'LOADING'">
      <label class="custom-checkbox-label">
        <input class="checkbox" type="checkbox" (throttledClick)="updateCustomerDetails()" appPreventDoubleClick
        [throttleTime]="3000" />
        <span> {{'public.checkout.saveCustomerDetailsForFuture' | translate}}</span>
      </label>
    </div>
    <div class="input-group valid-feedback font-size-secondary" *ngIf="customerDetailsUpdateStatus === 'SUCCESS'">
      <span> {{'public.checkout.customerDetailsUpdateSuccess' | translate}}</span>
    </div>
    <div class="input-group invalid-feedback font-size-secondary" *ngIf="customerDetailsUpdateStatus === 'FAILED'">
      <span> {{'public.checkout.errors.customerDetailsUpdateFailed' | translate}}</span>
    </div>
  </div>

</div>
